import TeamEditForm from "./team-edit-form";

const TeamForms = {
  Edit: TeamEditForm,
};

export default TeamForms;
